import React from 'react'
import '../styles/blog.css'
import BlogCards from '../components/BlogCards/BlogCards'

import Blog_1 from '../assets/images/BLOG-copy-2-1320x943.webp'
import Blog_2 from '../assets/images/DSC_5304-4-copy-THUMBNAIOL-copy-1320x943.webp'
import Helmet from '../components/Helmet/Helmet'

const Blog = () => {
  return <Helmet title={'Blog'}>
  <section className='blog__main'>
    <div className="w-1">
        <h1 className='__h1' >Blog</h1>
        <span className='dash'></span>
    </div>
    <div className="w-1 fsb blog__section">
        <BlogCards
        img={Blog_1}
        heading='Budget Lens for Macro Photography'
        text='Unlocking Affordable Excellence: Explore the Tokina AT-X M100 f/2.8 PRO D Macro lens, a budget-friendly gem for captivating mac...'
        path='/blog/budget-lens-for-macro-photography'
         />
        <BlogCards
        img={Blog_2}
        heading='The worlds rarest frog,Starry shrub frog(Pseudophilautus stellatus)'
        text='This frog was first recognized by E.F Kelaart from a single specimen,and was described as a new species. After that,it was los...'
        path='/blog/the-worlds-rarest-frogstarry-shrub-frogpseudophilautus-stellatus'
         />
    </div>
  </section>
  </Helmet> 
}

export default Blog